import { connect } from 'react-redux';
import { Currency } from '~/Api/Currency';
import { fetchCurrenciesIfNeeded as fetchCurrencies, State as CurrencyState } from '~/Currency';

import CurrencySelect from './CurrencySelect';

function mapStateToProps(state: { currency: CurrencyState }): {
	currencies: Currency[] | null;
} {
	return {
		currencies: state.currency.currencies,
	};
}

const actions: { onLoad: typeof fetchCurrencies } = {
	onLoad: fetchCurrencies,
};

export default connect(mapStateToProps, actions)(CurrencySelect);
